/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice\src\Content\Car\Pricing\MileageDurationSelector.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice
 * Created Date: Tuesday August 27th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday August 27th 2024 2:23:42 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import translator from 'MultiLanguage/TranslationWrapper';
import SliderPricingMUI from './SliderPricingMUI';
import { hightlightType } from './PricingHolder';

interface DataItem {
    id: string;
    Mileage: number;
    Month: number;
    Amount: number;
    Type: string;
}

interface MileageDurationSelectorProps {
    themeColor: string;
    data: DataItem[];
    type: "LLD" | "LOA";
    // setterMileage: React.Dispatch<React.SetStateAction<number>>;
    // setterMonth: React.Dispatch<React.SetStateAction<number>>;
    setter: React.Dispatch<React.SetStateAction<hightlightType>>;
    hightlight: hightlightType;
}

export default function MileageDurationSelector(props: MileageDurationSelectorProps) {
    const uniqueMileages = Array.from(new Set(props.data.filter(item => item.Type === props.type).map(item => item.Mileage)));
    const uniqueMonths = Array.from(new Set(props.data.filter(item => item.Type === props.type).map(item => item.Month)));

    // const [mileage, setMileage] = useState<number>(0);
    // const [month, setMonth] = useState<number>(0);

    // useEffect(() => {
    //     let minMileage = uniqueMileages.length > 0 ? Math.min(...uniqueMileages) : 0;
    //     if (mileage == 0 && minMileage != mileage)
    //         setMileage(minMileage);
    //     let minMonth = uniqueMonths.length > 0 ? Math.min(...uniqueMonths) : 0;
    //     if (month == 0 && minMonth != month)
    //         setMonth(minMonth);
    // }, [props.data]);

    const mileageMarks = uniqueMileages.map(value => ({ value, label: `${value.toLocaleString()} km` }));
    const monthMarks = uniqueMonths.map(value => ({ value, label: `${value} ${translator.decode("pricing.month")}` }));

    const HandleChangeMileage = (val: number) => {
        props.hightlight[props.type].mileage = val;
        props.setter({...props.hightlight});
        // setMileage(val);
        // props.setterMileage(val);
    };

    const HandleChangeMonth = (val: number) => {
        props.hightlight[props.type].month = val;
        props.setter({...props.hightlight});
        // setMonth(val);
        // props.setterMonth(val);
    };

    return (
        <div>
            <Typography variant="h6" style={{ marginTop: '20px' }}>{translator.decode("pricing.selectMileage")}</Typography>
            <SliderPricingMUI setter={HandleChangeMileage} value={props.hightlight[props.type].mileage} min={Math.min(...uniqueMileages)} max={Math.max(...uniqueMileages)} marks={mileageMarks} themeColor={props.themeColor} />
            <Typography variant="h6" style={{ marginTop: '20px' }}>{translator.decode("pricing.selectMonth")}</Typography>
            <SliderPricingMUI setter={HandleChangeMonth} value={props.hightlight[props.type].month} min={Math.min(...uniqueMonths)} max={Math.max(...uniqueMonths)} marks={monthMarks} themeColor={props.themeColor} />
        </div>
    );
};
